import React, { useEffect, useState } from "react";
import { Rating, Button, Divider, Chip, CircularProgress } from "@mui/material";
import {
  ArrowBack,
  ArrowCircleLeft,
  Favorite,
  LocalShipping,
  PriceChange,
  Redeem,
  ShoppingBag,
  Star,
  ThumbDownAlt,
  ThumbUpOffAlt,
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import axiosInstance from "../../../Configs/axios";
import { frequentlyQuestionsFn } from "../../../Services/Products/ProductDetail/FrequentlyQuestions";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { mostViewedProductsFn } from "../../../Services/Products/ProductDetail/MostViewedProducts";
import { addToCartFn } from "../../../Services/Cart/AddToCart";
import Checkout from "../../Checkout";
import WishlistButton from "../../../Shared/WishlistButton";
import { addToWishListFn } from "../../../Services/Products/AddToWishlist";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../../Redux/Actions/SnackBar";
import SearchModal from "../../../Shared/Search";
import CreateReview from "./CreateReview";
import ShareLink from "../../../Shared/ShareLink";
import EnterPincode from "../../../Shared/EnterPincode";
import { checkPincodeFn } from "../../../Services/Products/CheckPincode";
import { upVoteFn } from "../../../Services/Products/ProductDetail/UpVote";
import { downVoteFn } from "../../../Services/Products/ProductDetail/DownVote";
import { setCart } from "../../../Redux/Actions/Cart";
import { PostNotifyMeData } from "../../../Services/Products/Notify";

const ProductDetail = () => {
  const { id } = useParams();
  const [variantColor, setVariantColor] = useState("None");
  const [variantStorage, setVariantStorage] = useState("None");
  const [variant, setVariant] = useState("None");
  const [data, setData] = useState([]);
  const [detail, setDetail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [delivery, setDelivery] = useState("");
  const [faq, setFaq] = useState([]);
  const navigate = useNavigate();

  const productDetailData = () => {
    setIsLoading(true);
    axiosInstance
      .post(
        `api/product-deatils/?variant_color_value_id=${variantColor}&variant_storage_value_id=${variantStorage}&other_variants_value_id=${variant}`,
        { id: id }
      )
      .then((response) => {
        setIsLoading(false);
        setDetail(response.data.data[0].product_deatils[0]);
        setData(response.data.data[0].related_products);
      })
      .catch((error) => { });
  };

  useEffect(
    () => {
      productDetailData();
    },
    // eslint-disable-next-line
    [id]
  );
  const { mutate: frequentlyQuestions } = useMutation(frequentlyQuestionsFn, {
    onSuccess: (response) => {
      setFaq(response?.data.faq_data);
    },
  });
  useEffect(
    () => {
      frequentlyQuestions({
        product_variant_id: detail?.product_variant_value_list?.[0]?.variant_id,
      });
    },
    // eslint-disable-next-line
    [detail?.product_variant_value_list?.[0]?.variant_id]
  );

  const { data: mostViewedProducts } = useQuery(
    ["mostViewedProducts"],
    () => mostViewedProductsFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  useEffect(
    () => {
      productDetailData();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    // eslint-disable-next-line
    [id]
  );
  const client = useQueryClient();
  const { mutate: addToCart } = useMutation(addToCartFn, {
    onSuccess: (response) => {
      client.refetchQueries(["cartList"]);
      dispatch(
        setSnackbar({
          open: true,
          message: response.data.status,
          variant: "success",
        })
      );
    },
  });

  const handleAddToCart = (variantId) => {
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    addToCart(reqBody);
  };
  const cart = useSelector((cart) => cart.cart);

  const handleAddToCartWithOutLogin = (variant) => {
    if (cart?.map((item) => item?.item)?.includes(variant)) {
      dispatch(
        setSnackbar({
          open: true,
          message: "Already added to Cart",
          variant: "info",
        })
      );
    } else {
      dispatch(setCart([...cart, { item: variant, quantity: 1 }]));
      dispatch(
        setSnackbar({
          open: true,
          message: "Added to Cart",
          variant: "success",
        })
      );
    }
  };
  useEffect(() => {
    cart?.length !== 0 && localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const dispatch = useDispatch();
  const { mutate: addToWishlist } = useMutation(addToWishListFn, {
    onSuccess: (response) => {
      dispatch(
        setSnackbar({
          open: true,
          message: response?.data?.status,
          variant: "success",
        })
      );
      response.data.status === "Product added to wishlist" &&
        client.refetchQueries("myWishList");
    },
  });
  const { mutate: checkPincode } = useMutation(checkPincodeFn, {
    onSuccess: (response) => {
      response.data.response_code === 200 &&
        setDelivery(
          `Delivery within ${response.data.delivery_time} in ${response.data.city_name}`
        );
    },
  });
  const pincode = localStorage.getItem("pincode");
  useEffect(
    () => {
      pincode && checkPincode({ zipcode: pincode });
    },
    // eslint-disable-next-line
    [pincode]
  );
  const { mutate: upVote } = useMutation(upVoteFn, {
    onSuccess: (res) => {
      dispatch(
        setSnackbar({
          open: true,
          message: res.data.message,
          variant: "success",
        })
      );
    },
  });

  const { mutate: downVote } = useMutation(downVoteFn, {
    onSuccess: (res) => {
      dispatch(
        setSnackbar({
          open: true,
          message: res.data.message,
          variant: "success",
        })
      );
    },
  });
  const handleUpVote = (faq) => {
    upVote({
      product_variant_id: detail?.product_variant_value_list?.[0]?.variant_id,
      question_id: faq,
    });
    frequentlyQuestions({
      product_variant_id: detail?.product_variant_value_list?.[0]?.variant_id,
    });
  };
  const handleDownVote = (faq) => {
    downVote({
      product_variant_id: detail?.product_variant_value_list?.[0]?.variant_id,
      question_id: faq,
    });
    frequentlyQuestions({
      product_variant_id: detail?.product_variant_value_list?.[0]?.variant_id,
    });
  };

  const first =
    detail?.product_variant_value_list?.[0]?.product_rating_list?.filter(
      (i) => i.rate === 1
    );
  const second =
    detail?.product_variant_value_list?.[0]?.product_rating_list?.filter(
      (i) => i.rate === 2
    );
  const third =
    detail?.product_variant_value_list?.[0]?.product_rating_list?.filter(
      (i) => i.rate === 3
    );
  const fourth =
    detail?.product_variant_value_list?.[0]?.product_rating_list?.filter(
      (i) => i.rate === 4
    );
  const fifth =
    detail?.product_variant_value_list?.[0]?.product_rating_list?.filter(
      (i) => i.rate === 5
    );


  const { mutate: Notify } = useMutation(PostNotifyMeData, {
    onSuccess: (res) => {

      if (res?.data?.response_code === 200) {

        dispatch(
          setSnackbar({
            open: true,
            message: res?.data?.message,
            variant: "success",
          })
        );


      }
      else {


        dispatch(
          setSnackbar({
            open: true,
            message: res?.data?.message,
            variant: "error",
          })
        );
      }
    }
  })

  return isLoading ? (
    <div className="flex justify-center items-center min-h-screen">
      <CircularProgress />
    </div>
  ) : (
    <>
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl w-40 text-ellipsis overflow-hidden whitespace-nowrap">
            {detail?.product_variant_value_list?.[0]?.variant_name}
          </p>
        </span>
        <span className="flex gap-5 items-center">
          <SearchModal />
          <WishlistButton />
          <Checkout />
        </span>
      </div>

      <>
        <div className="lg:px-[8%] dark:bg-zinc-800 pt-[75px] px-3 flex-col flex gap-2">
          <Carousel
            autoPlay
            interval={4000}
            infiniteLoop
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            className="product"
          >
            {detail?.product_variant_value_list?.[0]?.varients_multiple_image?.map(
              (item) => {
                return (
                  <div key={item.id}>
                    <img alt="" src={item.variant_image} className="" />
                  </div>
                );
              }
            )}
          </Carousel>
          <Divider />
          <span className="flex justify-between items-start">
            <p className="text-lg font-semibold">
              {detail?.product_variant_value_list?.[0]?.variant_name}
            </p>
            <ShareLink
              url={window.location.href}
              variantName={
                detail?.product_variant_value_list?.[0]?.variant_name
              }
              variantImage={
                detail?.product_variant_value_list?.[0]?.variant_image
              }
            />
          </span>

          <span className="flex items-center gap-2">
            <p
              className={
                detail?.product_variant_value_list?.[0]?.stock_sataus ===
                  "In-stock"
                  ? "text-green-600 font-semibold"
                  : "text-red-600 font-semibold"
              }
            >
              {detail?.product_variant_value_list?.[0]?.stock_sataus}
            </p>
            <p className="text-sm">(Product HSN : {detail?.HSN})</p>
          </span>
          <Rating
            value={
              (detail && detail?.product_variant_value_list?.[0]?.rating) || 0
            }
            readOnly
            precision={0.5}
            className="!text-green-700"
          />

          <Chip
            color="success"
            size="small"
            label="Special Offers"
            className="w-fit !px-2"
            icon={<Redeem fontSize="small" />}
          />

          {detail?.discount_percent !== "0.0" ? (
            <p>
              <span className="line-through mx-1">
                {detail?.product_variant_value_list?.[0]?.variant_price}
              </span>
              <span className="font-bold mx-1">
                ₹{detail?.product_variant_value_list?.[0]?.actual_price}
              </span>
              <span className="text-green-600 mx-1">
                Save
                <span className="mx-1">
                  {Number(detail?.discount_percent)}%
                </span>
              </span>
            </p>
          ) : (
            <p className="font-bold mx-1">
              ₹{detail?.product_variant_value_list?.[0]?.actual_price}
            </p>
          )}

          {/* <div className="flex py-3">
            <div className="flex gap-3 flex-col bg-[#DEFEDA] rounded-r-xl rounded-l-md pl-3 py-2">
              <div className="border-r-[2px] text-xs border-dashed border-green-500 text-black py-2 px-3">
                <p>Flat ₹40 off </p>
                <p className="text-xs">
                  Apply cashback coupon for instant savings
                </p>
              </div>
            </div>
            <div className="flex px-5 items-center bg-[#DEFEDA] rounded-l-xl rounded-r-md">
              <Button variant="outlined" size="small" className="!rounded-sm">
                Apply
              </Button>
            </div>
          </div> */}

          {/* <div className="flex bg-zinc-100 dark:bg-zinc-800 py-1">
            <Button
              size="small"
              className="flex !bg-white dark:!bg-zinc-900 !rounded-none flex-col w-full"
            >
              <p className="text-blue-700">Dark Green</p>
              <p className="text-gray-500">Color(8)</p>
            </Button>
            <Divider orientation="vertical" />
            <Button
              size="small"
              className="flex !bg-white dark:!bg-zinc-900 !rounded-none flex-col w-full"
            >
              <p className="text-blue-700">M</p>
              <p className="text-gray-500">size-4</p>
            </Button>
          </div> */}

          <div className="flex gap-3 py-2 justify-between items-center px-3">
            <p className="text-xs">Find a Seller That delivers to you</p>

            <EnterPincode />
          </div>
          <Divider />
          <div className="flex flex-col gap-3">
            <div className="flex justify-between items-center">
              <span className="flex gap-3">
                <LocalShipping />
                <p>
                  {delivery ? delivery : "Deliver Expected within 2-3 Days"}
                </p>
              </span>
            </div>
            <Divider />
            <div className="flex justify-between items-center">
              <span className="flex gap-3">
                <ArrowCircleLeft color="primary" />
                <p>7 Days Return Policy</p>
              </span>
            </div>
            <Divider />
            <div className="flex justify-between items-center">
              <span className="flex gap-3">
                <PriceChange color="success" />
                <p>Cash on Delivery Available</p>
              </span>
            </div>
            <Divider />
          </div>

          <p className="font-bold">Product Details</p>
          <Divider />
          <div
            className="flex gap-5 text-sm"
            dangerouslySetInnerHTML={{ __html: detail?.description }}
          ></div>
          <Divider />
          {detail?.overview !== "None" &&
            detail?.overview !== "" &&
            detail?.overview !== "<p>None</p>" ? (
            <>
              <p className="font-bold"> Product Overview</p>
              <div
                className="flex flex-col"
                dangerouslySetInnerHTML={{ __html: detail?.overview }}
              ></div>
            </>
          ) : null}

          <p className="font-bold">Similar {detail?.title}</p>

          <div className="flex gap-2 p-2 overflow-x-auto hide-scroll">
            {data?.slice(0, 9)?.map((product) => {
              return (
                <div
                  className="bg-white dark:bg-zinc-900 p-2 rounded shadow"
                  onClick={() =>
                    navigate(`/product/${product.product_id}/${product.slug}`)
                  }
                >
                  <img src={product.product_image} alt="" className="" />
                  <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                    {product.title}
                  </p>
                  <p className="text-sm text-green-500">
                    From ₹{product.price}
                  </p>
                </div>
              );
            })}
          </div>

          <Divider />
          <div className="flex justify-between items-center gap-5 py-2">
            {detail?.product_variant_value_list?.[0]?.product_rating_list
              ?.length !== 0 ? (
              <p className="font-bold">Rating & Reviews</p>
            ) : (
              <p className="font-bold">Not Yet Rated</p>
            )}
            <CreateReview
              productId={detail?.product_variant_value_list?.[0]?.variant_id}
            />
          </div>
          {detail?.product_variant_value_list?.[0]?.product_rating_list
            ?.length !== 0 ? (
            <>
              <div className="flex items-center justify-between gap-5 w-full px-2">
                <div className="flex flex-col">
                  <Rating
                    value={
                      (detail &&
                        detail?.product_variant_value_list?.[0]?.rating) ||
                      0
                    }
                    readOnly
                    precision={0.5}
                    className="!text-green-700"
                  />
                  <p className="text-center">
                    (
                    <span className="px-1">
                      {
                        detail?.product_variant_value_list?.[0]
                          ?.product_rating_list?.length
                      }
                    </span>
                    Ratings)
                  </p>
                </div>
                <div className="flex flex-col w-full">
                  <div className="flex items-center space-x-1">
                    <span className="flex-shrink-0 w-12 text-sm">5 star</span>
                    <div className="flex-1 h-2 overflow-hidden rounded bg-gray-300">
                      <div className="bg-green-600 h-2 w-5/6"></div>
                    </div>
                    <span className="flex-shrink-0 w-12 text-sm text-right">
                      {fifth?.length}
                    </span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <span className="flex-shrink-0 w-12 text-sm">4 star</span>
                    <div className="flex-1 h-2 overflow-hidden rounded bg-gray-300">
                      <div className="bg-green-600 h-2 w-4/6"></div>
                    </div>
                    <span className="flex-shrink-0 w-12 text-sm text-right">
                      {fourth?.length}
                    </span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <span className="flex-shrink-0 w-12 text-sm">3 star</span>
                    <div className="flex-1 h-2 overflow-hidden rounded bg-gray-300">
                      <div className="bg-green-600 h-2 w-3/6"></div>
                    </div>
                    <span className="flex-shrink-0 w-12 text-sm text-right">
                      {third?.length}
                    </span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <span className="flex-shrink-0 w-12 text-sm">2 star</span>
                    <div className="flex-1 h-2 overflow-hidden rounded bg-gray-300">
                      <div className="bg-green-600 h-2 w-2/6"></div>
                    </div>
                    <span className="flex-shrink-0 w-12 text-sm text-right">
                      {second?.length}
                    </span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <span className="flex-shrink-0 w-12 text-sm">1 star</span>
                    <div className="flex-1 h-2 overflow-hidden rounded bg-gray-300">
                      <div className="bg-green-600 h-2 w-1/6"></div>
                    </div>
                    <span className="flex-shrink-0 w-12 text-sm text-right">
                      {first?.length}
                    </span>
                  </div>
                </div>
              </div>
              <Divider />
              <div className="flex flex-col">
                {detail?.product_variant_value_list?.[0]?.product_rating_list?.map(
                  (rating) => {
                    return (
                      <div className="flex flex-col gap-1">
                        <span className="flex items-start gap-3">
                          <Chip
                            color="primary"
                            size="small"
                            className="!rounded"
                            label={
                              <span className="flex items-start gap-1">
                                <p>{rating.rate}</p>
                                <Star className="!text-lg" />
                              </span>
                            }
                          />
                          <p className="font-semibold capitalize">
                            {rating.subject}
                          </p>
                        </span>
                        <p>{rating.comment}</p>
                        {rating.review_img !== "null" && (
                          <img
                            src={rating.review_img}
                            alt=""
                            className="w-14 h-14 object-cover"
                          />
                        )}

                        <p className="text-sm font-semibold">{rating.user}</p>
                        <p className="text-sm text-zinc-600">
                          Bhaarat Store Customer,
                          <span className="px-1">
                            {rating.create_at.slice(0, 10)}
                          </span>
                        </p>
                        <Divider className="!mb-2" />
                      </div>
                    );
                  }
                )}
              </div>
            </>
          ) : null}
          <p className="font-bold py-1">Question & Answers</p>
          {faq?.length !== 0 ? (
            <>
              <div className="flex flex-col text-sm">
                {faq?.map((faq) => {
                  return (
                    <>
                      <span className="flex gap-2 justify-between items-end py-3 px-1">
                        <span className="flex flex-col gap-3">
                          <p className="font-bold">
                            Q.<span className="pl-1">{faq.question}</span>
                          </p>
                          <span className="flex items-start">
                            <p className="font-bold pr-2">A. </p>{" "}
                            <p> {faq.answers.text}</p>
                          </span>

                          <p>
                            By
                            <span className="font-semibold px-1">
                              {faq.answers.answer_by}
                            </span>
                            on {faq.answers.created_at}
                          </p>
                        </span>
                        <div className="flex text-gray-400 dark:text- gap-3">
                          <span className="flex gap-1 items-center">
                            <ThumbUpOffAlt
                              fontSize="small"
                              onClick={() => handleUpVote(faq.id)}
                            />
                          </span>
                          <span className="font-semibold text-xl">
                            {faq.votes}
                          </span>
                          <span className="flex gap-1 items-center">
                            <ThumbDownAlt
                              fontSize="small"
                              onClick={() => handleDownVote(faq.id)}
                            />
                          </span>
                        </div>
                      </span>
                      <Divider />
                    </>
                  );
                })}
              </div>
            </>
          ) : (
            <p>Be first who ask the quetion</p>
          )}

          {/* <Button variant="outlined" size="small">
            Post Your Question
          </Button>

          <Divider /> */}
          <p className="font-semibold">Most Viewed Products</p>
          <div className="flex gap-2 p-2 overflow-x-auto mb-12 hide-scroll">
            {mostViewedProducts?.data?.data?.product_list?.map((product) => {
              return (
                <div
                  className="bg-white dark:bg-zinc-900 p-2 rounded shadow"
                  onClick={() =>
                    navigate(`/product/${product.id}/${product.slug}`)
                  }
                >
                  <img src={product.variant_image} alt="" className="" />
                  <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                    {product.title}
                  </p>
                  <p className="text-sm text-green-500">
                    From ₹{product.price}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex fixed flex-col bottom-0 z-50 bg-white dark:bg-zinc-900 w-full">
          <Divider />
          <div className="flex justify-between gap-4 py-2 px-3">
            <Button
              disableElevation
              startIcon={<ShoppingBag />}
              variant="outlined"
              className="!w-1/2"

              onClick={(event) => {
                event.stopPropagation();
                const token = localStorage.getItem("bhaarattoken");

                if (detail?.product_variant_value_list?.[0]?.stock_sataus !== "In-stock") {

                  token ? Notify({ product_variant_id: detail?.product_variant_value_list?.[0]?.variant_id }) :

                    dispatch(
                      setSnackbar({
                        open: true,
                        message: "Item is Out Of Stock",
                        variant: "error",
                      })
                    );



                  // enqueueSnackbar("Item is Out Of Stock", { variant: "error" });
                }

                else {
                  if (token) {

                    handleAddToCart(
                      detail?.product_variant_value_list?.[0]?.variant_id
                    );
                  } else {
                    handleAddToCartWithOutLogin(
                      detail?.product_variant_value_list?.[0]
                    )
                  }
                }

              }}












            // onClick={() =>














            //   localStorage.getItem("bhaarattoken")
            //     ? handleAddToCart(
            //       detail?.product_variant_value_list?.[0]?.variant_id
            //     )
            //     : handleAddToCartWithOutLogin(
            //       detail?.product_variant_value_list?.[0]
            //     )
            // }
            >
              {detail?.product_variant_value_list?.[0]?.stock_sataus !== "In-stock" ? "Notify Me 👋" : " Add to Bag"}
            </Button>
            <Button
              disableElevation
              startIcon={<Favorite />}
              variant="contained"
              className="!w-1/2"
              onClick={() =>
                localStorage.getItem("bhaarattoken")
                  ? addToWishlist({
                    add_quantity: 1,
                    product_id:
                      detail?.product_variant_value_list?.[0]?.variant_id,
                  })
                  : navigate("/login")
              }
            >
              Wishlist
            </Button>
          </div>
        </div>
      </>
    </>
  );
};

export default ProductDetail;
